// modules/ViewButton.js
import React        from 'react';
import LFSConstants from '../land-for-sale/LFSConstants';
import { Link }     from 'react-router';

class ViewButton extends React.Component {

	render() {
			return (
				<Link to={`${LFSConstants.LFS_PATH}/lot/${this.props.lot.slug}#search`} className="lfss-view-link">
					<div className="lfss-view">
						{this.props.children}
					</div>
				</Link>
			);
	}
}

export default ViewButton;


/** WEBPACK FOOTER **
 ** ./src/modules/common/ViewButton.js
 **/